export default function createWebhookStoreErrors(errors) {
  return {
    url: errors.url,
    webhookTypes: errors.webhook_types,
    isActive: errors.is_active,
  };
}
